import { TranslateLoader } from "@ngx-translate/core";
import { Observable } from "rxjs";

export abstract class TranslationLoader extends TranslateLoader {
  abstract get onResourcesLoaded(): Observable<void>;
  abstract resetResources(resources: string | string[] | Set<string>): Set<string>;
  abstract mergeResources(resources: string | string[] | Set<string>): Set<string>;
  abstract getLoadedKeys(): Observable<string>;
}
